import { render, staticRenderFns } from "./installation-details.vue?vue&type=template&id=b184741a&"
import script from "./installation-details.vue?vue&type=script&lang=js&"
export * from "./installation-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports